import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { ActiveInactiveFor, KeyValues3, Wrapper3, LocalService, Status, Wrappers3, PageKey } from '../../../service/local.service';

@Component({
  selector: 'app-language-section-config',
  templateUrl: './language-section-config.component.html',
  styleUrls: ['./language-section-config.component.scss']
})
export class LanguageSectionConfigComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["table"];
  source: Wrappers3; maxBodyHeight = 0;
  wrapper: Wrapper3 = {
    content: { key: '', v1: '' } as KeyValues3
  } as Wrapper3;
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.configurationManagementService.ensurePageActions(PageKey.LanguageSectionConfig);
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
      this.onLoad();
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    this.languageManagementService.getLanguageConfigSection('', this.source == null ? null : this.source.paging).subscribe(result => {
      this.source = result;     
    });
  }

  onSave() {
    this.languageManagementService.saveLanguageConfigSection(this.wrapper).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success) {
        this.onReset();
        this.onLoad();
      }
    });
  }

  onActiveInactiveStatus(strId: string) {
    this.languageManagementService.activeInactiveStatus(strId, ActiveInactiveFor.LanguageSection).subscribe(result => {
      if (result == Status.Success) {
        const updatedItem = this.source.items.find(x => x.key == strId);
        updatedItem.v2 = updatedItem.v2 == "1" ? "0" : "1";
      }      
    });
  }

  onReset() {
    this.wrapper = {
      content: { key: '', v1: '' } as KeyValues3
    } as Wrapper3;
  }
}
